var mp = mp || {};

// FancyBox
//-----------------------------------------------------------------
mp.fancyBox = function() {
    var $trigger = $("[data-fancybox]");

    if (!$trigger.length) {
        return;
    }
    
    $trigger.fancybox({
        infobar: false,
        buttons: [
            "close"
        ],
    });
};



// Background image holder
//-----------------------------------------------------------------
mp.backgroundHolder = function() {
    var $element = $(".background-holder");

    if (!$element.length) {
        return;
    }

    $element.each(function(){
        var $img = $(this).find('img');
        var $imageSrc = $img.attr('src');
        $img.remove();
        $(this).css('background-image', 'url('+$imageSrc+')').addClass('show');
    });
};



// Tabs
//-----------------------------------------------------------------
mp.tabs = function() {
    var $element = $(".tabs");

    if (!$element.length) {
        return;
    }

    $(document).on('click', '.tabs [data-toggle]', function(e){
        e.preventDefault();
        
        var $tabID = $(this).data("toggle");

        $(this).parents('.tabs').find("[data-toggle], .tabs__content").removeClass("active");
        
        $(this).parents('.tabs').find(".tabs__nav [data-toggle='"+$tabID+"']").addClass("active");
        $(this).parents('.tabs').find("#"+$tabID).addClass("active");
    })
};



// Init Selectric
//-----------------------------------------------------------------
mp.selectric = function() {
    var $trigger = $('.form__select');

    if (!$trigger.length) {
        return;
    }

    $trigger.selectric({
        disableOnMobile: false,
        nativeOnMobile: true,
    });
}




// Links on table rows
//-----------------------------------------------------------------
mp.tableRowLinks = function() {
    
    $(document).on('click', 'tr[data-url]', function(e) {
        if ($(e.target).is("i.icon-download")===false){
            e.preventDefault();

            $url = $(this).data('url');
            location.href = $url;
        }
    });
};

$(document).ready(function (){
    mp.fancyBox();
    mp.tabs();
    mp.selectric();
    mp.tableRowLinks();
    //mp.backgroundHolder();
});